import { createTheme } from "@mui/material";



 const Theme = (languageOrientation) =>
 
 createTheme({
    typography: {
        // Tell Material UI what the font-size on the html element is.
        htmlFontSize:10, /* 10px / 16px = 0.625 = 62.5% that is Percentage of user's browser font-size setting */
        textTransform:'capitalise',
      },
      direction:languageOrientation,
    palette: {
      mode: 'light',
      primary: {
        main:'#000000',
        contrastText: '#f2f2f2'
    },
      secondary: {
        main: '#c8c8c8'},
    },
     bniRed:{
      main:'#cf2030'
     },
     graniteGrey:{
      main:'#64666A'
     },
     sterlingLightGrey:{
      main:'#f2f2f2'
     },
     trueWhite:{
      main:'#ffffff'
     },
     sterlingGrey:{
      main: '#c8c8c8'
     }
  });
  export const ResponsiveFontTheme =  Theme;